import { LazyMotion, domAnimation, m, useReducedMotion } from 'motion/react';
import './registrationExperience.css';

interface SuccessPassMarkProps {
  compact?: boolean;
}

/**
 * A ticket-shaped confirmation mark. Its silhouette is intentionally distinct
 * from the shield previously used by the registration result.
 */
export function SuccessPassMark({ compact = false }: SuccessPassMarkProps): JSX.Element {
  const reduceMotion = useReducedMotion();

  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        className={`fte-success-mark ${compact ? 'fte-success-mark--compact' : ''}`}
        role="img"
        aria-label="Inscrição confirmada"
        initial={reduceMotion ? false : { opacity: 0, scale: 0.82, rotate: -3 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={reduceMotion ? { duration: 0 } : { type: 'spring', stiffness: 280, damping: 18 }}
      >
        <span className="fte-success-mark__scan" aria-hidden="true" />
        <svg viewBox="0 0 160 160" aria-hidden="true" focusable="false">
          <m.path
            className="fte-success-mark__ticket"
            d="M31 25h98c5.5 0 10 4.5 10 10v25c-10.3 1.8-18 10.8-18 21.5s7.7 19.7 18 21.5v22c0 5.5-4.5 10-10 10H31c-5.5 0-10-4.5-10-10v-22c10.3-1.8 18-10.8 18-21.5S31.3 61.8 21 60V35c0-5.5 4.5-10 10-10Z"
            pathLength={1}
            initial={reduceMotion ? false : { pathLength: 0, opacity: 0.25 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={reduceMotion ? { duration: 0 } : { duration: 0.55, ease: 'easeOut' }}
          />
          <path className="fte-success-mark__rail" d="M48 45h64M48 117h64" />
          <m.path
            className="fte-success-mark__check"
            d="m55 81 17 17 35-38"
            pathLength={1}
            initial={reduceMotion ? false : { pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={reduceMotion ? { duration: 0 } : { delay: 0.28, duration: 0.38, ease: 'easeOut' }}
          />
        </svg>
        <span className="fte-success-mark__label" aria-hidden="true">PASSE OK</span>
      </m.div>
    </LazyMotion>
  );
}
